<template>
  <v-col cols="12" class="px-0">
    <v-list class="py-0 location-lab-reports-list" dense>
      <v-list-item
        v-for="report in fullListVisible ? sortedReports : sortedReports.slice(0, 4)"
        :key="report.id"
        class="location-lab-reports-element hover-list-element px-2"
      >
        <v-list-item-content>
          <v-list-item-title class="text-body-2">
            <v-row no-gutters class="flex-nowrap" align="center">
              <v-col cols="auto" style="max-width: 80%">
                <v-tooltip bottom color="font" max-width="300">
                  <template #activator="{ on }">
                    <div class="text-body-2 location-lab-reports-text" v-on="on">
                      {{ report.name }}
                    </div>
                  </template>
                  <div style="word-break: break-all;">
                    {{ report.name }}
                  </div>
                </v-tooltip>
              </v-col>
              <v-spacer />
              <v-col cols="auto" style="max-width: 20%">
                <v-row no-gutters align="center">
                  <v-col cols="auto">
                    <base-rounded-button
                      icon="mdi-play"
                      iconSize="15"
                      :customSize="22"
                      :tooltip="$i18n.t('button.generateStatistics')"
                      @click="toggleReportGenerate(report)"
                      :disabled="calculating"
                    />
                  </v-col>
                  <v-col cols="auto">
                    <dots-menu
                      v-if="enlargment"
                      @delete="toggleDelete(report)"
                      @edit="toggleEdit(report)"
                      :items="dotsItems"
                      font-size="19px"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <list-toggler v-if="reports.length > 4" v-model="fullListVisible" />
    </v-list>
    <main-dialog
      v-if="isDeletingLoaded"
      :is-visible.sync="isDeletingVisible"
      :loading="isDeletingLoading"
      :title="$i18n.t('sidebar.locationLab.deleteReportTitle')"
      :body="$i18n.t('sidebar.locationLab.deleteReportAgree', { name: deletingReport.name })"
      agree-text="dialog.agreeDelete"
      @agree="handleDeleteReport"
    />
    <template v-if="currentReport">
      <location-lab-statistics-dialog
        v-if="isEditDialogLoaded"
        :is-visible.sync="isEditDialogVisible"
        :report="currentReport"
      />
    </template>
  </v-col>
</template>
<script>
import { call } from 'vuex-pathify';
import DotsMenu from '@/components/DotsMenu';
import ListToggler from '@/components/ListToggler';
export default {
  name: 'LocationLabReportsList',
  components: {
    DotsMenu,
    ListToggler,
    LocationLabStatisticsDialog: () => import('@/components/LocationLabStatisticsDialog'),
    MainDialog: () => import('@/components/MainDialog'),
  },
  props: {
    reports: {
      type: Array,
      required: true,
    },
    calculating: {
      type: Boolean,
      default: false,
    },
    enlargment: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    currentReport: undefined,
    dotsItems: [{ name: 'edit' }, { name: 'delete' }],
    fullListVisible: false,
    deletingReport: undefined,
    isDeletingVisible: false,
    isDeletingLoaded: false,
    isDeletingLoading: false,
    isEditDialogVisible: false,
    isEditDialogLoaded: false,
  }),
  computed: {
    sortedReports() {
      return [...this.reports]?.sort((a, b) => b.id - a.id);
    },
  },
  methods: {
    deleteReport: call('locationLab/deleteLocationLabReport'),
    async handleDeleteReport() {
      this.isDeletingLoading = true;
      try {
        await this.deleteReport(this.deletingReport.id);
        this.isDeletingVisible = false;
        this.isDeletingLoading = false;
      } catch {
        this.isDeletingVisible = false;
        this.isDeletingLoading = false;
      }
    },
    toggleDelete(report) {
      this.deletingReport = report;
      this.isDeletingLoaded = true;
      this.isDeletingVisible = true;
    },
    toggleEdit(report) {
      this.currentReport = JSON.parse(JSON.stringify(report));
      this.isEditDialogLoaded = true;
      this.isEditDialogVisible = true;
    },
    toggleReportGenerate(report) {
      this.$emit('toggleReportGenerate', report);
    },
  },
};
</script>
<style lang="scss" scoped>
.location-lab-reports-element {
  @include border(bottom);
  text-align: left;
  min-height: 36px;
  max-height: 36px;
}
.location-lab-reports-list {
  border-radius: 4px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px -1px 0px rgba(0, 0, 0, 0.15) !important;
}
.location-lab-reports-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
